<section class="loading">
    <img src="assets/imgs/loading-icon.jpg" />
</section>
